
import React from 'react'

export default props => <div style={Object.assign({ margin: '120px 60px', padding: '20px 0px', position: 'relative', backgroundColor: '#FFFFFF', borderRadius: 8, boxShadow: '0px 40px 80px rgba(0, 0, 0, 0.25)', overflow: 'hidden' }, props.style)}>
    {props.children}
</div>